module.exports = __webpack_public_path__ + "img/di_16_RecCard.ec7f5d2d.png";